import React, { useState, useEffect } from 'react';

export default function CurrencyInput({ value, onChange, label, decimals = 0, autoFocus = false }) {
  const [isFocused, setIsFocused] = useState(false);
  const [localStr, setLocalStr] = useState('');

  useEffect(() => {
    if (!isFocused) {
      setLocalStr(value === 0 ? '' : value.toFixed(decimals));
    }
  }, [value, isFocused, decimals]);

  const handleChange = (e) => {
    let val = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
    const parts = val.split('.');
    if (parts.length > 2) val = parts[0] + '.' + parts.slice(1).join('');
    setLocalStr(val);
    const num = parseFloat(val);
    onChange(isNaN(num) ? 0 : num);
  };

  const displayValue = isFocused 
    ? localStr 
    : (value === 0 ? '' : new Intl.NumberFormat('fr-FR', { 
        minimumFractionDigits: decimals, 
        maximumFractionDigits: decimals 
      }).format(value));

  return (
    <div className="relative w-full">
      <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1 ml-1">
        {label}
      </label>
      <div className="relative group">
        <input
          type="text"
          className="w-full bg-slate-50 border border-slate-200 rounded-xl py-2.5 pl-3 pr-8 text-slate-900 font-bold text-base text-right focus:bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all outline-none shadow-sm group-hover:border-slate-300 placeholder:text-slate-300"
          value={displayValue}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder="0"
          autoFocus={autoFocus}
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs font-bold select-none">
          €
        </span>
      </div>
    </div>
  );
}